export default __webpack_public_path__ + "static/media/KZ.T.08.Е0663.a57b0e74.svg";